import React, { useContext, useEffect, useState } from "react";
import { BASE_URL_API } from "../../References/url";
import AuthContext from "../../Store/auth-context";
import { motion } from "framer-motion";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import styles from "./AllCatalogues.module.css";
import { humanReadableTimePassed } from "../../Helper/Algos";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const AllCatalogues = () => {
    const authCtx = useContext(AuthContext);
    const [allCatalogues, setAllCatalogues] = useState([]);
    const [catalogueRequestStatus, setCatalogueRequestStatus] = useState(false)
    const [isMakingRequest, setIsMakingRequest] = useState(false)

    const loginData = JSON.parse(authCtx.loginData)
    console.log(loginData)
    const getAllCatalogues = async () => {
        const response = await fetch(BASE_URL_API + "/getAllCatalogues", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                clientIdentifier: authCtx.clientIdentifier,
            }),
        });

        if (!response.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const respo = await response.json();
            if (respo.status === "success") {
                setAllCatalogues(respo.response);
            } else if (respo.message === "token Expired, login again!") {
                authCtx.logout();
            }
        }
    };

    useEffect(() => {
        getAllCatalogues();
    }, []);

    const requestACatalogue = async () => {
        setIsMakingRequest(true)
        const response = await fetch(BASE_URL_API + "/requestACatalogue", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                clientIdentifier: authCtx?.clientIdentifier,
                brandName: loginData?.brandName
            }),
        });

        if (!response.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const respo = await response.json();
            if (respo.status === "success") {
                setCatalogueRequestStatus(true);
                toast(`Requested successfully!`)
            } else if (respo.message === "token Expired, login again!") {
                authCtx.logout();
            }
        }
        setIsMakingRequest(false)
    }


    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>All Catalogues</h2>

            {allCatalogues?.length > 0 ?
                <div className={styles.catalogueList}>
                    {allCatalogues?.map((item, index) => (
                        <motion.div
                            to={`/catalogue/${item?.catalogueIdentifier}`}
                            key={index}
                            className={styles.catalogueCard}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: index * 0.1 }}
                        >
                            <Link
                                to={`/catalogue/${item?.catalogueIdentifier}`}
                            >
                                <div className={styles.catalogueHeader}>
                                    <div>{item.name}</div>
                                    <span className={styles.statusIcon}>
                                        {item.isActive === "1" ? (
                                            <FaCheckCircle color="green" />
                                        ) : (
                                            <FaTimesCircle color="red" />
                                        )}
                                    </span>
                                </div>
                                <div className={styles.clientName}>{item.clientFirmName}</div>
                                <p className={styles.clientAddress}>{item.clientAddress}</p>
                                <p className={styles.remarks}>{item.remarks}</p>
                                <div className={styles.timeAgo}>
                                    Shared {humanReadableTimePassed(item?.createdOn)}
                                </div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
                :
                <div className={styles.noCatalogueContainer}>
                    <div className={styles.message}>
                        No Catalogue Available
                    </div>
                    <div className={styles.subMessage}>
                        Looks like you don't have a catalogue yet. Let's request one!
                    </div>
                    {isMakingRequest === true ?
                        <button className={styles.requestButton}
                        >
                            Requesting, Please wait...
                        </button>
                        :
                        <button className={styles.requestButton}
                            onClick={() => requestACatalogue()}
                        >
                            Request a Catalogue
                        </button>
                    }
                </div>

            }

        </div>
    );
};

export default AllCatalogues;
